import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import type { IRsvpResponse } from "@/models"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { RsvpResponse } from "@/models"

export interface IGetRsvpResponseArgsParams {
  eventAlbumId?: number
  token?: string
  guestId?: number
}

export async function getRsvpResponse(eventVaultId: number, emailToken?: string, albumId?: number, guestId?: number) {
  if (!eventVaultId) {
    throw new Error("Missing `eventVaultId` when attempting to get rsvp response. Please ensure `eventVaultId` is provided.")
  }

  const options: AxiosRequestConfig = {}

  const params: IGetRsvpResponseArgsParams = {
    token: emailToken,
    eventAlbumId: albumId,
    guestId,
  }

  if (params.token || params.eventAlbumId || params.guestId) {
    options.params = params
  }

  const response = await v1.get<ServerResponseV1<IRsvpResponse>>(`/events/${eventVaultId}/rsvp`, options)

  return RsvpResponse.fromResponse(response.data.data)
}

export const GET_RSVP_RESPONSE = "getRsvpResponse"

export function useGetRsvpResponse(eventVaultId?: MaybeRef<number | undefined>, emailToken?: MaybeRef<string | undefined>, albumId?: MaybeRef<number | undefined>, guestId?: MaybeRef<number | undefined>) {
  return useQuery({
    queryKey: [GET_RSVP_RESPONSE, eventVaultId, emailToken, albumId, guestId],
    queryFn: () => getRsvpResponse(toValue(eventVaultId)!, toValue(emailToken), toValue(albumId), toValue(guestId)),
    enabled: !!toValue(eventVaultId),
  })
}
